<h2 mat-dialog-title>
	{{ typeLabel }} — {{ promise.loanNumber }}
</h2>

<mat-dialog-content>
	<dl class="facts">
		<dt>Customer</dt>
		<dd>{{ promise.customerName || '—' }}</dd>

		<dt>Amount</dt>
		<dd>{{ FormatUtil.formatCurrency(promise.amount) }}</dd>

		<dt>Promise Date</dt>
		<dd>{{ promise.promiseDate }}</dd>

		<dt>Payment Method</dt>
		<dd>{{ paymentMethodLabel }}</dd>

		<dt>Status</dt>
		<dd>
			<span
				class="status-badge"
				[style.--status-color]="PromiseToPayStatus.getColor(promise.status)"
			>
				{{ promise.status }}
			</span>
		</dd>

		<dt>Owner</dt>
		<dd>{{ promise.ownerName || '—' }}</dd>

		<ng-container *ngIf="promise.kapchargeTransaction as txn">
			<dt>Payment</dt>
			<dd>KapCharge transaction {{ txn.id }} — {{ txn.status || 'unknown' }}</dd>
		</ng-container>

	</dl>

	<mat-divider></mat-divider>

	<h3 class="section-title">History</h3>
	<lmc-promise-to-pay-timeline
		[entries]="promise.timeline"
	></lmc-promise-to-pay-timeline>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-stroked-button type="button" (click)="onClose()">Close</button>
</mat-dialog-actions>
